module.exports = __webpack_public_path__ + "img/SCHEME_DESKTOP.f7689903.svg";